export default __webpack_public_path__ + "static/media/payout-grey.09440e6e.svg";